import React from 'react';
import {
    Box,
    Button,

    Typography,
} from '@mui/material';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import { useNavigate } from 'react-router-dom';

import DateRangePicker from '../../../components/Date-range-picker/DateRangePicker';
import AuditLogTable from './AuditLogTable';
import WidgetsDropdown from '../../../layout/WidgetsDropdown';
import AuditFilter from './AuditFilter';

const AuditLog = () => {
    const navigate = useNavigate();

    return (
        <>
            <Box>
                <Button
                    onClick={() => navigate('/reports')}
                    style={{
                        color: '#1A1F36',
                        fontSize: '24px',
                        fontWeight: '600',
                        display: 'flex',
                        alignItems: 'center',
                        gap: 2,
                        marginBottom: '24px',
                        textTransform: 'capitalize',
                        padding: '0',
                        marginLeft: '-10px'
                    }}
                >
                    <KeyboardArrowLeftIcon
                        sx={{ color: '#1760EC', width: '30px', height: '30px' }}
                    />
                    Reports
                </Button>
            </Box>

            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                <Typography variant="h6" fontWeight="600" sx={{ fontSize: '17px' }}>
                    Audit log
                </Typography>
                <Box className="d-flex gap-10 align-items-center">
                    <WidgetsDropdown
                        widgetOptions={[
                            'Author',
                            'Time',
                            'Action',
                            'Object',
                            'Members',
                            'Details',
                        ]}
                        defaultSelected={[
                            'Author',
                            'Time',
                            'Action',
                            'Object',
                            'Members',
                            'Details',
                        ]}
                    />
                </Box>
            </Box>


            <Box className="mt-24" sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
                <DateRangePicker />
                <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    {/* <Button
                        component="label"
                        variant="contained"
                        sx={{
                            borderRadius: '50px',
                            fontSize: '14px',
                            background: '#0076FE',
                            border: '1px solid #0076FE',
                            color: '#fff',
                            boxShadow: 'none',
                        }}
                        tabIndex={-1}
                        startIcon={<FilterwIcon />}
                    >
                        Filter
                    </Button>  */}

                    <AuditFilter />
                </Box>
            </Box>

            <Box className="mt-24">
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Box className="mb-24">
                        <Typography sx={{ color: '#1A1F36', fontSize: '17px', fontWeight: 600 }}>
                            Acadecraft Private Limited
                        </Typography>
                        <Typography sx={{ fontSize: '14px', color: '#9095A1' }}>Asia - Kolkata</Typography>
                    </Box>
                </Box>
            </Box>
            <AuditLogTable />
        </>
    );
};

export default AuditLog;
